import { createGlobalStyle } from "styled-components";
import SpendZoomIconsWOFF from "assets/fonts/SpendZoomIcons/SpendZoomIcons.woff";
import SpendZoomIconsTTF from "assets/fonts/SpendZoomIcons/SpendZoomIcons.ttf";
import SpendZoomIconsSVG from "assets/fonts/SpendZoomIcons/SpendZoomIcons.svg";

export default createGlobalStyle`
    @font-face {
      font-family: 'SpendZoomIcons';
      src:
        url(${SpendZoomIconsTTF}) format('truetype'),
        url(${SpendZoomIconsWOFF}) format('woff'),
        url(${SpendZoomIconsSVG}) format('svg');
      font-weight: normal;
      font-style: normal;
      font-display: block;
    }

    [class^="icon-"], [class*=" icon-"] {
      font-family: 'SpendZoomIcons' !important;
      speak: never;
      font-style: normal;
      font-weight: normal;
      font-variant: normal;
      text-transform: none;
      line-height: 1;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    .icon-filter_list:before {
      content: "\\e94a";
    }
    .icon-sort:before {
      content: "\\e94b";
    }
    .icon-twitter:before {
      content: "\\e947";
    }
    .icon-youtube:before {
      content: "\\e948";
    }
    .icon-reddit:before {
      content: "\\e949";
    }
    .icon-thumbs-down:before {
      content: "\\e943";
    }
    .icon-insights:before {
      content: "\\e944";
    }
    .icon-spark:before {
      content: "\\e945";
    }
    .icon-transactions:before {
      content: "\\e946";
    }
    .icon-radio-unchecked:before {
      content: "\\e900";
    }
    .icon-checkbox-checked:before {
      content: "\\e901";
    }
    .icon-checkbox-unchecked:before {
      content: "\\e902";
    }
    .icon-radio-checked:before {
      content: "\\e903";
    }
    .icon-thumb-down:before {
      content: "\\e905";
    }
    .icon-thumb-up:before {
      content: "\\e906";
    }
    .icon-indeterminate-checked:before {
      content: "\\e904";
    }
    .icon-facebook-circle:before {
      content: "\\e907";
    }
    .icon-add-outline:before {
      content: "\\e908";
    }
    .icon-add-solid:before {
      content: "\\e909";
    }
    .icon-arrow-thin-down:before {
      content: "\\e90a";
    }
    .icon-arrow-thin-left:before {
      content: "\\e90b";
    }
    .icon-arrow-thin-right:before {
      content: "\\e90c";
    }
    .icon-arrow-thin-up:before {
      content: "\\e90d";
    }
    .icon-block:before {
      content: "\\e90e";
    }
    .icon-bookmark:before {
      content: "\\e90f";
    }
    .icon-calendar:before {
      content: "\\e910";
    }
    .icon-chart:before {
      content: "\\e911";
    }
    .icon-chart-pie:before {
      content: "\\e912";
    }
    .icon-checkmark:before {
      content: "\\e913";
    }
    .icon-checkmark-outline:before {
      content: "\\e914";
    }
    .icon-cheveron-down:before {
      content: "\\e915";
    }
    .icon-cheveron-left:before {
      content: "\\e916";
    }
    .icon-cheveron-right:before {
      content: "\\e917";
    }
    .icon-cheveron-up:before {
      content: "\\e918";
    }
    .icon-close:before {
      content: "\\e919";
    }
    .icon-close-outline:before {
      content: "\\e91a";
    }
    .icon-close-solid:before {
      content: "\\e91b";
    }
    .icon-cloud-upload:before {
      content: "\\e91c";
    }
    .icon-cog:before {
      content: "\\e91d";
    }
    .icon-conversation:before {
      content: "\\e91e";
    }
    .icon-credit-card:before {
      content: "\\e91f";
    }
    .icon-document:before {
      content: "\\e920";
    }
    .icon-document-add:before {
      content: "\\e921";
    }
    .icon-dots-horizontal-triple:before {
      content: "\\e922";
    }
    .icon-download:before {
      content: "\\e923";
    }
    .icon-edit-pencil:before {
      content: "\\e924";
    }
    .icon-exclamation-outline:before {
      content: "\\e925";
    }
    .icon-exclamation-solid:before {
      content: "\\e926";
    }
    .icon-home:before {
      content: "\\e927";
    }
    .icon-information-outline:before {
      content: "\\e928";
    }
    .icon-information-solid:before {
      content: "\\e929";
    }
    .icon-lock-closed:before {
      content: "\\e92a";
    }
    .icon-menu:before {
      content: "\\e92b";
    }
    .icon-minus-outline:before {
      content: "\\e92c";
    }
    .icon-minus-solid:before {
      content: "\\e92d";
    }
    .icon-mood-happy-solid:before {
      content: "\\e92e";
    }
    .icon-mood-neutral-solid:before {
      content: "\\e92f";
    }
    .icon-mood-sad-solid:before {
      content: "\\e930";
    }
    .icon-news-paper:before {
      content: "\\e931";
    }
    .icon-notifications:before {
      content: "\\e932";
    }
    .icon-phone:before {
      content: "\\e933";
    }
    .icon-printer:before {
      content: "\\e934";
    }
    .icon-question:before {
      content: "\\e935";
    }
    .icon-refresh:before {
      content: "\\e936";
    }
    .icon-reload:before {
      content: "\\e937";
    }
    .icon-send:before {
      content: "\\e938";
    }
    .icon-share-alt:before {
      content: "\\e939";
    }
    .icon-shield:before {
      content: "\\e93a";
    }
    .icon-star-full:before {
      content: "\\e93b";
    }
    .icon-tag:before {
      content: "\\e93c";
    }
    .icon-time:before {
      content: "\\e93d";
    }
    .icon-tuning:before {
      content: "\\e93e";
    }
    .icon-upload:before {
      content: "\\e93f";
    }
    .icon-user-solid-circle:before {
      content: "\\e940";
    }
    .icon-view-hide:before {
      content: "\\e941";
    }
    .icon-view-show:before {
      content: "\\e942";
    }
    .icon-facebook2:before {
      content: "\\ea91";
    }
    .icon-instagram:before {
      content: "\\ea92";
    }
    .icon-whatsapp:before {
      content: "\\ea93";
    }
    .icon-github:before {
      content: "\\eab0";
    }
    .icon-file-pdf:before {
      content: "\\eadf";
    }
    .icon-file-excel:before {
      content: "\\eae2";
    }

`;
